import React, { useRef } from 'react'
import Table, { TableSortOrder, useResize, TableRenderers } from '../Tables/Table'
import TransactionsTable from '../Tables/TransactionsTable'
import { Column } from 'react-base-table'
import { Spinner } from 'react-bootstrap'
import { TransactionProxy } from '../../../sharedModels/TransactionProxy'
import { useTerminatesHook } from './Hook'
import { SweepstakeSurveyProxy } from '../../../sharedModels/SweepstakeSurveyProxy'

interface TerminatesProps {
}

export interface TerminatesState {
    isLoading: boolean
    terminates: SweepstakeSurveyProxy[],
}

export let Terminates: React.FC<TerminatesProps> = (props) => {

    let { state } = useTerminatesHook()
    let { isLoading, terminates } = state
    const componentRef = useRef(null)
    const { width, height } = useResize(componentRef)

    if (isLoading) {
        return (
            <div className='admin-cashouts-container' ref={componentRef}>
                <Spinner animation='border' variant='primary' />
            </div>
        )
    }

    return (
        <div className='admin-cashouts-container'>
            <Table rows={terminates} width={width} height={height} columns={generateColumns()} data={generateData(terminates)} />
        </div>

    )
}

const generateData = (completes: SweepstakeSurveyProxy[]): Column[] => {
    return completes.map((complete, idx) => {
        return {
            ...complete,
            index: idx + 1,
            id: complete.firestoreId,
            parentId: null,
            width: 150,
        }
    })
}

const generateColumns = (): Column[] => {
    let columns: Column[] = [
        {
            key: 'index',
            dataKey: 'index',
            title: 'Idx',
            width: 75,
            renderer: (row => {
                let { rowData } = row
                let { index } = rowData
                return TableRenderers.default(index)
            })
        },
        {
            key: 'endTimestamp',
            dataKey: 'endTimestamp',
            title: 'Date',
            width: 140,
            sortable: true,
            order: TableSortOrder.Descending,
            renderer: (row => {
                let { rowData } = row
                let sweepstakeSurvey: SweepstakeSurveyProxy = rowData
                let { endTimestamp } = sweepstakeSurvey
                return TableRenderers.relativeDateRender(endTimestamp)
            })
        },
        {
            key: 'userId',
            dataKey: 'userId',
            title: 'UserId',
            width: 250,
            renderer: (row => {
                let { rowData } = row
                let sweepstakeSurvey: SweepstakeSurveyProxy = rowData
                let { userId } = sweepstakeSurvey
                return TableRenderers.userIdRender(userId)
            })
        },
        {
            key: 'userEarningsTerminateCents',
            dataKey: 'userEarningsTerminateCents',
            title: 'User Terminate Earnings',
            width: 110,
            renderer: (row => {
                let { rowData } = row
                let sweepstakeSurvey: SweepstakeSurveyProxy = rowData
                let { userEarningsTerminateCents } = sweepstakeSurvey
                return TableRenderers.centsToDollarRender(userEarningsTerminateCents)
            })
        },
        {
            key: 'userEarningsCents',
            dataKey: 'userEarningsCents',
            title: 'User Earnings',
            width: 110,
            renderer: (row => {
                let { rowData } = row
                let sweepstakeSurvey: SweepstakeSurveyProxy = rowData
                let { userEarningsCents } = sweepstakeSurvey
                return TableRenderers.centsToDollarRender(userEarningsCents)
            })
        },
        {
            key: 'source',
            dataKey: 'source',
            title: 'Source',
            width: 110,
            renderer: (row => {
                let { rowData } = row
                let sweepstakeSurvey: SweepstakeSurveyProxy = rowData
                let { source } = sweepstakeSurvey
                return TableRenderers.default(`${source}`)
            })
        },
        {
            key: 'userDurationSeconds',
            dataKey: 'userDurationSeconds',
            title: 'User Duration',
            width: 110,
            renderer: (row => {
                let { rowData } = row
                let sweepstakeSurvey: SweepstakeSurveyProxy = rowData
                let { userDurationSeconds } = sweepstakeSurvey
                return TableRenderers.secondsToMinutesRender(userDurationSeconds)
            })
        },
        {
            key: 'lucidSurveyNumber',
            dataKey: 'lucidSurveyNumber',
            title: 'Lucid Survey Number',
            width: 110,
            sortable: true,
            renderer: (row => {
                let { rowData } = row
                let sweepstakeSurvey: SweepstakeSurveyProxy = rowData
                let { lucidSurveyNumber } = sweepstakeSurvey
                lucidSurveyNumber = lucidSurveyNumber || 0
                return TableRenderers.default(`${lucidSurveyNumber}`)
            })
        },
    ]
    return columns
}

export default Terminates
